
import { CityPageTemplate } from '@/components/seo/CityPageTemplate';
import { Sun, Building, Truck } from 'lucide-react';

const PhoenixPage = () => {
  return (
    <CityPageTemplate
      city="Phoenix"
      state="Arizona"
      stateAbbr="AZ"
      population="1.6 million+"
      majorIndustries={["aerospace", "technology", "healthcare", "manufacturing", "tourism"]}
      businessChallenges={[
        "Extreme heat workplace safety requirements",
        "Rapid business growth and scaling challenges",
        "Seasonal workforce fluctuations from tourism",
        "Water usage and environmental compliance",
        "Desert climate equipment and safety concerns"
      ]}
      peoSolutions={[
        "Heat safety programs and workplace protection",
        "Scalable HR solutions for rapid growth companies",
        "Seasonal workforce management and flexible benefits",
        "Environmental compliance and safety training",
        "Desert-specific occupational health programs"
      ]}
      localBusinessTypes={[
        { name: "Aerospace", description: "Defense contractors, aviation, space technology" },
        { name: "Technology", description: "Software, semiconductors, data centers" },
        { name: "Healthcare", description: "Hospitals, clinics, medical devices" },
        { name: "Manufacturing", description: "Electronics, automotive, industrial" }
      ]}
      metaDescription="Find the best PEOs in Phoenix with The PEO App. Compare quotes from top Phoenix Professional Employer Organizations offering specialized HR solutions for aerospace, technology, and manufacturing companies."
      keyFeatures={[
        {
          icon: Sun,
          title: "Heat Safety Expertise",
          description: "Specialized workplace safety programs for Phoenix's extreme heat conditions with comprehensive employee protection protocols."
        },
        {
          icon: Building,
          title: "Aerospace Industry Focus",
          description: "Expert HR services for Phoenix's aerospace and defense sector including security clearance management and federal compliance."
        },
        {
          icon: Truck,
          title: "Rapid Growth Support",
          description: "Scalable HR solutions designed for Phoenix's fast-growing business environment with flexible workforce management."
        }
      ]}
    />
  );
};

export default PhoenixPage;
